import { render } from "./DlAuxDistributionSection.vue?vue&type=template&id=1a589dc6&scoped=true"
import script from "./DlAuxDistributionSection.vue?vue&type=script&lang=js"
export * from "./DlAuxDistributionSection.vue?vue&type=script&lang=js"

import "./DlAuxDistributionSection.vue?vue&type=style&index=0&id=1a589dc6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a589dc6"]])

export default __exports__